import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, BookOpen, PenLine, User, BarChart3 } from 'lucide-react';

/**
 * 底部导航栏组件
 * 提供应用主要功能的快速访问入口
 * @returns {JSX.Element} 渲染底部导航栏
 */
function TabBar() {
  const location = useLocation();
  const path = location.pathname;

  const tabs = [
    {
      name: '首页',
      icon: Home,
      to: '/',
      active: path === '/'
    },
    {
      name: '题库',
      icon: BookOpen,
      to: '/question-bank',
      active: path === '/question-bank'
    },
    {
      name: '考试',
      icon: PenLine,
      to: '/exam',
      active: path === '/exam'
    },
    {
      name: '报告',
      icon: BarChart3,
      to: '/study-report',
      active: path === '/study-report'
    },
    {
      name: '我的',
      icon: User,
      to: '/profile',
      active: path === '/profile'
    }
  ];

  return (
    <div className="fixed bottom-0 bg-white border-t border-gray-100 h-[60px] flex items-center shadow-md w-full max-w-[450px]">
      <div className="w-full flex justify-around items-center">
        {tabs.map((tab) => (
          <Link
            key={tab.name}
            to={tab.to}
            className={`flex flex-col items-center ${
              tab.active 
                ? 'text-primary' 
                : 'text-gray-400'
            }`}
          >
            <div className={`rounded-full p-2 ${
              tab.active 
                ? 'bg-primary-light/10' 
                : ''
            }`}>
              <tab.icon 
                className={`w-6 h-6 ${
                  tab.active 
                    ? 'text-primary' 
                    : 'text-gray-400'
                }`} 
              />
            </div>
            <span className="text-xs mt-0.5">{tab.name}</span>
          </Link>
        ))}
      </div>
    </div>
  );
}

export default TabBar; 